import { type FC } from "react";
import { Button } from "antd";
import leftIcon from "../../../assets/images/left-arr.svg";
import rightGrayIcon from "../../../assets/images/right-arr-gray.svg";
import rightWhiteIcon from "../../../assets/images/right-arr-white.svg";

export interface FormNavigationButtonsProps {
  cancelLabel: string;
  nextLabel: string;
  isStepValid: boolean;
  isNextDisabled: boolean;
  onCancelClick: () => void;
  onNextClick: () => void;
}

const FormNavigationButtons: FC<FormNavigationButtonsProps> = ({
  cancelLabel,
  nextLabel,
  isStepValid,
  isNextDisabled,
  onCancelClick,
  onNextClick,
}) => {
  return (
    <div className="bottom-sec-btn">
      <Button
        className="cancel-btn"
        data-testid="cancel-btn"
        onClick={onCancelClick}
      >
        <img src={leftIcon} className="left-icon" alt="left-icon" />
        {cancelLabel}
      </Button>

      <Button
        className={`next-btn ${isStepValid ? "" : "active"}`}
        htmlType="button"
        data-testid="next-btn"
        disabled={isNextDisabled}
        onClick={onNextClick}
      >
        {nextLabel}
        {nextLabel !== "Finish" && (
          <img
            src={isStepValid ? rightWhiteIcon : rightGrayIcon}
            alt="left-icon"
          />
        )}
      </Button>
    </div>
  );
};

export default FormNavigationButtons;
